import {BaseService} from "../../infrastructure/domain-services/base-service";
import {LoggerUtils} from "../../infrastructure/utils/logger/logger-utils";
import {BaseAnalyticsEvent} from "../../infrastructure/models/analytics/base-analytics-event";
import {AppStore} from "../../core/app/app-store";
import {AppModuleState} from "../../core/app/models/app-module.state";
import {HistoryManager} from "../../core/managers/history-manager";
import {APP} from "../../core/app/consts";
import {debounce} from "../../infrastructure/debounce/debounce";

export class BaseAnalyticsProvider extends BaseService {
  name: APP.ANALYTICS.PROVIDERS;
  appStore: AppStore;
  logger: LoggerUtils;
  historyManager: HistoryManager;

  static injectables = [AppStore, LoggerUtils, HistoryManager];

  constructor(appStore: AppStore, logger: LoggerUtils, historyManager: HistoryManager) {
    super();

    this.logger = logger;
    this.appStore = appStore;
    this.historyManager = historyManager;
    this.debounceSendPageViewEvent = debounce((pathname) => this.sendPageViewEvent(pathname), 100);
    this.historyManager.registerToRouteChanged((pathname) => {
      this.debounceSendPageViewEvent(pathname)
    });

  }

  init() {
    // Prevent duplicate sending of page view for widgets
    // (getInitialRoute changing route before init)
    if(!this.appStore.state.settings.isWidget){
      // this.debounceSendPageViewEvent(this.historyManager.currentPath);
    }
  }
  createEvent(event: BaseAnalyticsEvent) {}
  send() {}
  flush() {}
  sendPageViewEvent(url: String) {}

  get appState(): AppModuleState {
    return this.appStore.state;
  }
}
